<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Home from '@/components/home.vue'
export default {
  name: 'App',
  components: {
    Home
  },
  data() {
    return {}
  },
  watch: {},
  created() {},
  methods: {}
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
}
ul,
ul li,
dl,
dt,
dd,
form,
img,
p,
form {
  margin: 0;
  padding: 0;
  border: none;
  list-style-type: none;
  vertical-align: top;
}
#app {
  font-family: 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.flex {
  display: flex;
  flex-flow: row wrap;
}
.flex-box {
  flex: 1;
  overflow: hidden;
}
.flex-x-start {
  justify-content: flex-start;
}
.flex-x-center {
  justify-content: center;
}
.flex-x-between {
  justify-content: space-between;
}
.flex-x-end {
  justify-content: flex-end;
}
.flex-y-start {
  align-items: flex-start;
}
.flex-y-center {
  align-items: center;
}
.flex-y-end {
  align-items: flex-end;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clear:after {
  content: '';
  display: block;
  clear: both;
}
.t-c {
  text-align: center;
}
</style>
